import { button, resetButton } from '@/theme/utils';
import { ComponentProps } from 'react';

export const PrimaryButton = (props: ComponentProps<'button'>) => <button css={[resetButton, button({ isPrimary: true })]} {...props} />;

export const SecondaryButton = (props: ComponentProps<'button'>) => <button css={[resetButton, button({ isPrimary: false })]} {...props} />;
